import { IconWrapper } from '../runtime';
export default IconWrapper('function', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M8.0005 7.79299L2.05564 4.32516M8.0005 7.79299L13.9454 4.32516M8.0005 7.79299V14.9998M2.05564 4.32516C1.84819 4.59289 1.73047 4.92585 1.73047 5.27556V10.7241C1.73047 11.2784 2.02617 11.7906 2.50618 12.0677L7.22478 14.792C7.46479 14.9306 7.73264 14.9998 8.0005 14.9998M2.05564 4.32516C2.17699 4.16855 2.32903 4.03426 2.50618 3.93198L7.22478 1.2077C7.7048 0.930563 8.2962 0.930563 8.77621 1.2077L13.4948 3.93198C13.672 4.03426 13.824 4.16855 13.9454 4.32516M13.9454 4.32516C14.1528 4.59289 14.2705 4.92585 14.2705 5.27556V10.7241C14.2705 11.2784 13.9748 11.7906 13.4948 12.0677L8.77621 14.792C8.53621 14.9306 8.26835 14.9998 8.0005 14.9998",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});